
import React, { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Column, Row } from 'atoms/Layout';
import ChannelSelect from 'organisms/ChannelSelect';
import InsightThemes from 'templates/InsightThemes';
import InsightScores from 'templates/InsightScores';
import { HorizontalSpaceFlex1 } from 'atoms/Space';

const Insights: FC = () => {
    const { channelId } = useParams();
    const navigate = useNavigate();

    const changeChannel = (channelId?: string) => {
        if (!channelId) {
            navigate('/dashboard/insights')
            return
        }

        navigate(`/dashboard/insights/${channelId}`)
    }

    return <Column size="full" gap="large">
        <Row>
            <Column>
                <ChannelSelect channelId={channelId} onChange={changeChannel}/>
            </Column>
            <HorizontalSpaceFlex1 />
        </Row>
        <Row gap="large">
            <InsightThemes channelId={channelId} />
            <InsightScores channelId={channelId} />
        </Row>
    </Column>
}

export default Insights;
